import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import editing from 'assets/img/dashboard.png';

const Starter = () => (
  <Card>
    <CardBody className="overflow-hidden p-lg-6">
      <Row className="align-items-center justify-content-center">
        <Col lg={8}>
          <img src={editing} className="img-fluid" alt="" />
        </Col>
        <Col lg={3} className="pl-lg-4 my-3 text-center text-lg-left">
          <h3>PlanBoard</h3>
          <p className="lead">
            A shared view of plans and schedules within your organization. Multiple users within your organization can
            see each calendar or the Overview using the navigation bar to the left.
          </p>
          <Link className="btn btn-falcon-primary" to="/calendars">
            Go to your calendars
          </Link>
        </Col>
      </Row>
    </CardBody>
  </Card>
);

export default Starter;
